module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-winter-3200.0caea1cd.svg";